import { render, staticRenderFns } from "./StepCreate.vue?vue&type=template&id=413f49af&scoped=true"
import script from "./StepCreate.vue?vue&type=script&lang=js"
export * from "./StepCreate.vue?vue&type=script&lang=js"
import style0 from "./StepCreate.vue?vue&type=style&index=0&id=413f49af&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "413f49af",
  null
  
)

export default component.exports